/*jslint browser: true, long: true, this: true */
/*global blacksunplc */

/**
 * Lightbox component
 */
(function () {
    "use strict";

    var behaviors = blacksunplc.behaviors;            // import * as behaviors from "module:blacksunplc/behaviors"
    var objects = blacksunplc.objects;                // import * as objects   from "module:blacksunplc/objects"
    var classes = blacksunplc.classes;                // import * as classes   from "module:blacksunplc/classes"
    var events = blacksunplc.events;                  // import * as events    from "module:blacksunplc/events"
    var classList = blacksunplc.attributes.classList; // import {classList}    from "module:blacksunplc/attributes"
    var nodes = blacksunplc.nodes;                    // import * as nodes     from "module:blacksunplc/nodes"
    var jsonml = blacksunplc.jsonml;                  // import * as jsonml    from "module:blacksunplc/jsonml"

    var exports = {};

    /**
     * @constructor
     * @implements {blacksunplc.CustomBehavior<!HTMLButtonElement>}
     */
    exports.LightboxBehavior = classes.define({

        /**
         * @this {!exports.LightboxBehavior}
         * @param {!HTMLButtonElement} host
         */
        "constructor": function (host) {
            this.host = host;
        },

        "methods": /** @lends {exports.LightboxBehavior.prototype} */{

            /**
             * @override
             * @this {!exports.LightboxBehavior}
             */
            "connectedCallback": function () {
                var lexicalThis = this;
                events.add(lexicalThis.host, "click", function(event) {
                    lexicalThis.show(event);
                });

                events.add(document, "keyup", function (event) {
                    var KEY_CODE_ESCAPE = 27;
                    if (event.keyCode === KEY_CODE_ESCAPE) {
                        lexicalThis.close();
                    }
                });
            },

            close: function () {
                var lightboxElement = document.querySelector(".bs-lightbox-overlay");
                if (lightboxElement) {
                    nodes.remove(lightboxElement);
                    classList(document.body).remove("overflow-hidden");
                }
            },

            show: function (/** !Event */ event) {
                var lexicalThis = this;
                event.preventDefault();
                var element = /** @type {!Element} */ (event.currentTarget);
                var dataUrl = element.getAttribute("data-url");
                var dataType = element.getAttribute("data-type");
                var newElement;
                var closeBtn = /** @type {!Element} */ (jsonml.render(
                    ["button", {"class": "close-lightbox-btn"}]
                ));
                if (dataType === "video") {
                    newElement = /** @type {!Element} */ (jsonml.render(
                        ["div", {"class": "video-container"},
                            ["video", {"playsinline": "", "controls": "", "autoplay": ""},
                                ["source", {"src": dataUrl, "type": "video/mp4"}]
                            ]
                        ]
                    ));
                } else if (dataType === "youtube") {
                    newElement = /** @type {!Element} */ (jsonml.render(
                        ["div", {"class": "video-container"},
                            ["iframe", { "src": dataUrl, "frameborder": 0, "allow": "autoplay; fullscreen;" }]
                        ]
                    ));
                } else {
                    newElement = /** @type {!Element} */ (jsonml.render(
                        ["img", {"src": dataUrl, "alt": ""}]
                    ));
                }
                var elementWrapper = /** @type {!Element} */ (jsonml.render(
                    ["div", {"class": "element-wrapper"},
                        [newElement]
                    ]
                ));
                var lightboxElement = /** @type {!Element} */ (jsonml.render(
                    ["div", {"class": "bs-lightbox-overlay is-active"},
                        [closeBtn],
                        [elementWrapper]
                    ]
                ));

                events.add(closeBtn, "click", lexicalThis.close);
                events.add(lightboxElement, "click", lexicalThis.close);
                events.add(elementWrapper, "click", function (event) {
                    event.stopPropagation();
                });

                document.body.appendChild(lightboxElement);
                closeBtn.focus();
                elementWrapper.style.transform = "scale(1)";
                classList(document.body).add("overflow-hidden");
            }
        }

    });

    /* jshint ignore:start */

    /** @type {(undefined|!exports.LightboxBehavior)} */
    HTMLButtonElement.prototype.LightboxBehavior; // this fails in IE/Edge 7 and below

    /* jshint ignore:end */

    behaviors.define("lightbox-btn", exports.LightboxBehavior, { "extends": "button" });

    objects.freeze(exports);

}());
/* Lightbox component end here */
